<template>
    <div class="criar-campo-formulario">
        <Accordion>
            <AccordionTab header="Design do Formulário">
                <div class="accordion-content">
                    <div class="form-group">
                        <label>Selecionar Imagem</label>
                        <div class="image-upload-container">
                            <input type="file" ref="fileInput" @change="handleImageUpload" accept="image/*" style="display: none" />
                            <div class="image-display" @click="$refs.fileInput.click()">
                                <span v-if="!designConfig.imagemFundo" class="image-placeholder">
                                    {{ designConfig.nomeImagem || 'Imagem.png' }}
                                </span>
                                <img v-else :src="designConfig.imagemFundo" alt="Preview" class="image-preview" />
                                <div class="image-actions">
                                    <button
                                        v-if="designConfig.imagemFundo"
                                        type="button"
                                        class="image-remove-btn"
                                        @click.stop="removerImagem"
                                        title="Remover imagem"
                                    >
                                        <span class="material-symbols-outlined">close</span>
                                    </button>
                                    <button type="button" class="image-upload-btn">
                                        <span class="material-symbols-outlined">upload</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <button @click="$refs.fileInput.click()" class="btn-adicionar-campo">Adicionar</button>
                    </div>

                    <div class="form-group">
                        <label>Cor de Fundo</label>
                        <div class="color-input-container">
                            <input v-model="designConfig.corFundo" type="color" class="color-input" />
                            <InputText v-model="designConfig.corFundo" type="text" class="color-text" placeholder="#ffffff" />
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Tipografia</label>
                        <select v-model="designConfig.tipografia" class="typography-select">
                            <option value="Arial">Arial</option>
                            <option value="Poppins">Poppins</option>
                            <option value="Helvetica">Helvetica</option>
                            <option value="Georgia">Georgia</option>
                            <option value="Times New Roman">Times New Roman</option>
                            <option value="Roboto">Roboto</option>
                            <option value="Open Sans">Open Sans</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Tamanho da Fonte</label>
                        <select v-model="designConfig.tamanhoFonte" class="typography-select">
                            <option value="10.67px">8</option>
                            <option value="12px">9</option>
                            <option value="13.33px">10</option>
                            <option value="14.67px">11</option>
                            <option value="16px">12</option>
                            <option value="18.67px">14</option>
                            <option value="24px">18</option>
                            <option value="32px">24</option>
                            <option value="40px">30</option>
                            <option value="48px">36</option>
                            <option value="64px">48</option>
                            <option value="80px">60</option>
                            <option value="96px">72</option>
                            <option value="128px">96</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Espaçamento</label>
                        <InputNumber v-model="designConfig.gap" style="width: 100%" :min="0" :max="100" />
                        <Slider v-model="designConfig.gap" style="margin: 4px 4px 0px 4px" :min="0" :max="100" :step="1" />
                    </div>

                    <div class="form-group">
                        <label>Margem</label>
                        <InputNumber v-model="designConfig.padding" style="width: 100%" :min="0" :max="100" />
                        <Slider v-model="designConfig.padding" style="margin: 4px 4px 0px 4px" :min="0" :max="100" :step="1" />
                    </div>

                    <div class="form-group">
                        <div class="p-field-checkbox">
                            <Checkbox inputId="binary" v-model="designConfig.botaoLimpar" :binary="true" />
                            <label for="binary">Adicionar Botão Limpar Campos</label>
                        </div>
                    </div>

                    <div class="form-group buttons-group">
                        <button @click="salvarMudancas" class="btn-salvar-mudancas">Salvar Mudanças</button>
                        <button @click="reverterAlteracoes" class="btn-reverter-alteracoes">Reverter Alterações</button>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script setup>
import { ref, reactive, defineEmits, watch, defineProps, onMounted } from 'vue';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Checkbox from 'primevue/checkbox';

const props = defineProps({
    modelValue: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['design-change', 'update:modelValue']);

const fileInput = ref(null);

const designPadrao = {
    imagemFundo: '',
    nomeImagem: 'Imagem.png',
    corFundo: '#ffffff',
    tipografia: 'Arial',
    tamanhoFonte: '16px',
    gap: 16,
    padding: 24,
    botaoLimpar: false,
    botaoLimparCor: '#0e88b3',
    botaoLimparAlinhamento: 'end',
};

const designConfig = reactive({ ...designPadrao });

const mesclarValoresIniciais = (valores) => {
    if (!valores) return;

    const parseValue = (value) => (value ? parseInt(String(value).replace('px', ''), 10) : 0);

    const merged = {
        ...designPadrao,
        ...valores,
        gap: parseValue(valores.gap),
        padding: parseValue(valores.padding),
    };

    Object.assign(designConfig, merged);
};

onMounted(() => {
    mesclarValoresIniciais(props.modelValue);
});

watch(
    () => props.modelValue,
    (novoValor) => {
        mesclarValoresIniciais(novoValor);
    },
    { deep: true, immediate: true }
);

function handleImageUpload(event) {
    const file = event.target.files[0];
    if (file) {
        designConfig.nomeImagem = file.name;

        const reader = new FileReader();
        reader.onload = (e) => {
            designConfig.imagemFundo = e.target.result;
            emitDesignChange();
        };
        reader.readAsDataURL(file);
    }
}

function removerImagem() {
    designConfig.imagemFundo = '';
    designConfig.nomeImagem = 'Imagem.png';

    if (fileInput.value) {
        fileInput.value.value = '';
    }

    emitDesignChange();
}

function salvarMudancas() {
    const payload = {
        ...designConfig,
        gap: `${designConfig.gap}px`,
        padding: `${designConfig.padding}px`,
    };
    emit('design-change', payload);
    emit('update:modelValue', payload);
}

function reverterAlteracoes() {
    Object.assign(designConfig, { ...designPadrao });

    if (fileInput.value) {
        fileInput.value.value = '';
    }

    emitDesignChange();
}

function emitDesignChange() {
    // Esta função agora é chamada apenas em interações que devem ser reativas,
    // como upload ou remoção de imagem. O salvamento principal é feito em 'salvarMudancas'.
    const payload = {
        ...designConfig,
        gap: `${designConfig.gap}px`,
        padding: `${designConfig.padding}px`,
    };
    emit('update:modelValue', payload);
}
</script>

<style scoped lang="scss">
.criar-campo-formulario {
    width: 100%;
}

.accordion-content {
    color: #666;
    font-size: 14px;
    padding: 0 8px;
}

.form-group {
    margin-bottom: 16px;
}

.form-group label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
}

.image-upload-container {
    width: 100%;
}

.image-display {
    position: relative;
    width: 100%;
    min-height: 44px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #f8f9fa;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    transition: all 0.2s ease;
}

.image-display:hover {
    border-color: #0f97c7;
    background: #f0f8ff;
}

.image-placeholder {
    color: #666;
    font-size: 14px;
}

.image-preview {
    max-width: 100px;
    max-height: 32px;
    object-fit: cover;
    border-radius: 4px;
}

.image-actions {
    display: flex;
    gap: 4px;
    align-items: center;
}

.image-upload-btn {
    background: none;
    border: none;
    color: #0f97c7;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-upload-btn:hover {
    background: rgba(15, 151, 199, 0.1);
}

.image-remove-btn {
    background: none;
    border: none;
    color: #dc2626;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.image-remove-btn:hover {
    background: rgba(220, 38, 38, 0.1);
}

.btn-adicionar-campo {
    width: 100%;
    padding: 12px 16px;
    background: #fff;
    border: 1px solid #0f97c7;
    border-radius: 4px;
    color: #0f97c7;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-adicionar-campo:hover {
    background: #f0f8ff;
}

.color-input-container {
    display: flex;
    gap: 8px;
    align-items: center;
}

.color-input {
    width: 44px;
    height: 32px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 4px;
    cursor: pointer;
    background: none;
}

.color-text {
    flex: 1;
    box-sizing: border-box;
}

.color-picker-btn {
    width: 44px;
    height: 44px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #f8f9fa;
    color: #666;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.color-picker-btn:hover {
    border-color: #0f97c7;
    color: #0f97c7;
}

.typography-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background: #fff;
    min-height: 44px;
    box-sizing: border-box;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%230F97C7' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    padding-right: 40px;
}

.typography-select:focus {
    outline: none;
    border-color: #0f97c7;
    box-shadow: 0 0 0 3px rgba(15, 151, 199, 0.1);
}

.buttons-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.btn-salvar-mudancas {
    width: 100%;
    padding: 12px 16px;
    background: #0f97c7;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-salvar-mudancas:hover {
    background: #0d85a8;
}

.btn-reverter-alteracoes {
    width: 100%;
    padding: 12px 16px;
    background: #fff;
    border: 1px solid #dc2626;
    border-radius: 4px;
    color: #dc2626;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-reverter-alteracoes:hover {
    background: #fef2f2;
}

.color-text:focus,
.typography-select:focus {
    outline: none;
    border-color: #0f97c7;
    box-shadow: 0 0 0 3px rgba(15, 151, 199, 0.1);
}

.material-symbols-outlined {
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    font-size: 20px;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link) {
    background: #fff;
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 8px;
    font-weight: normal;
    font-size: 14px;
    color: #252529;
    border-radius: 0;
    box-shadow: none;
    justify-content: space-between;
    width: 100%;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon) {
    color: #0f97c7;
    order: 2;
    margin-left: auto;
    transition: transform 0.2s ease;
}

:deep(.p-accordion .p-accordion-header.p-highlight .p-accordion-header-link .p-accordion-toggle-icon) {
    transform: rotate(180deg);
}

:deep(.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link) {
    background: #f8f9fa;
    color: #252529;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link:focus) {
    box-shadow: none;
    outline: none;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link:hover) {
    background: #f8f9fa;
}

:deep(.p-accordion .p-accordion-content) {
    background: #fff;
    border: none;
    padding: 16px 0;
    border-top: none;
}

:deep(.p-accordion) {
    border: none;
    box-shadow: none;
    width: 100%;
}

:deep(.p-accordion .p-accordion-tab) {
    border: none;
    margin-bottom: 0;
    width: 100%;
}

:deep(.p-accordion .p-accordion-header) {
    border: none;
    border-radius: 0;
    width: 100%;
}

:deep(.p-accordion .p-accordion-tab:not(:last-child)) {
    margin-bottom: 0;
}
</style>
